Object.defineProperty(exports,"__esModule",{value: true});
exports.default=window.GrimoireJS&&window.GrimoireJS.lib.fundamental?window.GrimoireJS.lib.fundamental.Sort.ImportResolver:undefined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/grimoirejs-fundamental/ref/Sort/ImportResolver.js
// module id = 39
// module chunks = 0